import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { useTheme } from "../context/ThemeContext";
const Navbar = () => {
	const { isDarkMode, toggleTheme } = useTheme();
	const { language, toggleLanguage, t } = useLanguage();
	const [scrolled, setScrolled] = useState(false);
	const [activeSection, setActiveSection] = useState("about");
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	useEffect(() => {
		const handleScroll = () => {
			// Set scrolled state based on scroll position
			const isScrolled = window.scrollY > 20;
			if (isScrolled !== scrolled) {
				setScrolled(isScrolled);
			}

			// Determine active section based on scroll position
			const sections = [
				"home",
				// "projects",
				"careerPlan",
				"experience",
				"education",
				"contact",
			];
			for (const section of sections.reverse()) {
				const element = document.getElementById(section);
				if (element) {
					const rect = element.getBoundingClientRect();
					if (rect.top <= 150) {
						setActiveSection(section);
						break;
					}
				}
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [scrolled]);

	// Close mobile menu when clicking a link
	const handleLinkClick = () => {
		setMobileMenuOpen(false);
		
	};

	return (
		<motion.nav
			initial={{ opacity: 0, y: -20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.5 }}
			className={`sticky top-0 z-50 bg-gray-900 dark:bg-gray-800 text-white p-4 shadow-md transition-all duration-300 ${
				scrolled ? "shadow-lg bg-opacity-90 backdrop-blur-md" : ""
			}`}>
			<div className="container mx-auto flex justify-between items-center">
				<motion.div
					className="text-xl font-bold"
					whileHover={{ scale: 1.05, color: "#3B82F6" }}>
					{t("portfolio")}
				</motion.div>

				{/* Desktop Menu */}
				<div className="hidden md:flex items-center space-x-6">
					<NavLink
						href="https://julien.stock4me.com/#home"
						active={activeSection === "home"}
						onClick={handleLinkClick}>
						{t("home")}
					</NavLink>
					<NavLink
						href="https://julien.stock4me.com/#about"
						active={activeSection === "about"}
						onClick={handleLinkClick}>
						{t("about")}
					</NavLink>
					{/* <NavLink
						href="https://julien.stock4me.com/#projects"
						active={activeSection === "projects"}
						onClick={handleLinkClick}>
						{t("projects")}
					</NavLink> */}
					<NavLink
						href="https://julien.stock4me.com/#careerPlan"
						active={activeSection === "careerPlan"}
						onClick={handleLinkClick}>
						{t("careerPlan")}
					</NavLink>
					<NavLink
						href="https://julien.stock4me.com/#experience"
						active={activeSection === "experience"}
						onClick={handleLinkClick}>
						{t("experience")}
					</NavLink>
					<NavLink
						href="https://julien.stock4me.com/#education"
						active={activeSection === "education"}
						onClick={handleLinkClick}>
						{t("education")}
					</NavLink>
					<NavLink
						href="https://julien.stock4me.com/#contact"
						active={activeSection === "contact"}
						onClick={handleLinkClick}>
						{t("contact")}
					</NavLink>
					<LanguageToggle
						language={language}
						toggleLanguage={toggleLanguage}
					/>
					<ThemeToggle
						isDarkMode={isDarkMode}
						toggleTheme={toggleTheme}
					/>
				</div>

				{/* Mobile Menu Button */}
				<div className="flex md:hidden items-center space-x-3">
					<LanguageToggle
						language={language}
						toggleLanguage={toggleLanguage}
					/>
					<ThemeToggle
						isDarkMode={isDarkMode}
						toggleTheme={toggleTheme}
					/>
					<motion.button
						onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
						whileTap={{ scale: 0.9 }}
						className="p-2 rounded-md hover:bg-gray-700 transition-colors"
						aria-label="Toggle menu">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="h-6 w-6"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor">
							{mobileMenuOpen ? (
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M6 18L18 6M6 6l12 12"
								/>
							) : (
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M4 6h16M4 12h16M4 18h16"
								/>
							)}
						</svg>
					</motion.button>
				</div>
			</div>

			{/* Mobile Menu Dropdown */}
			<AnimatePresence>
				{mobileMenuOpen && (
					<motion.div
						initial={{ opacity: 0, height: 0 }}
						animate={{ opacity: 1, height: "auto" }}
						exit={{ opacity: 0, height: 0 }}
						transition={{ duration: 0.3 }}
						className="md:hidden bg-gray-800 mt-4 rounded-lg overflow-hidden">
						<div className="flex flex-col py-2">
							<NavLink
						href="https://julien.stock4me.com/#home"
						active={activeSection === "home"}
						mobile
						onClick={handleLinkClick}>
						{t("home")}
					</NavLink>
							<NavLink
								href="https://julien.stock4me.com/#about"
								active={activeSection === "about"}
								mobile
								onClick={handleLinkClick}>
								{t("about")}
							</NavLink>
							{/* <NavLink
								href="#projects"
								active={activeSection === "projects"}
								mobile
								onClick={handleLinkClick}>
								{t("projects")}
							</NavLink> */}
							<NavLink
								href="https://julien.stock4me.com/#careerPlan"
								active={activeSection === "careerPlan"}
								mobile
								onClick={handleLinkClick}>
								{t("careerPlan")}
							</NavLink>
							<NavLink
								href="https://julien.stock4me.com/#experience"
								active={activeSection === "experience"}
								mobile
								onClick={handleLinkClick}>
								{t("experience")}
							</NavLink>
							<NavLink
								href="https://julien.stock4me.com/#education"
								active={activeSection === "education"}
								mobile
								onClick={handleLinkClick}>
								{t("education")}
							</NavLink>
							<NavLink
								href="https://julien.stock4me.com/#contact"
								active={activeSection === "contact"}
								mobile
								onClick={handleLinkClick}>
								{t("contact")}
							</NavLink>
						</div>
					</motion.div>
				)}
			</AnimatePresence>
		</motion.nav>
	);
};

// Theme toggle button component
const ThemeToggle = ({ isDarkMode, toggleTheme }) => {
	return (
		<motion.button
			onClick={toggleTheme}
			whileHover={{ scale: 1.1, rotate: 15 }}
			whileTap={{ scale: 0.9 }}
			className="p-2 rounded-full hover:bg-gray-700 transition-colors flex items-center justify-center"
			aria-label={
				isDarkMode ? "Switch to light mode" : "Switch to dark mode"
			}>
			{isDarkMode ? (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="h-5 w-5"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor">
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
					/>
				</svg>
			) : (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="h-5 w-5"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor">
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={2}
						d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
					/>
				</svg>
			)}
		</motion.button>
	);
};

// Improved Language toggle button component
const LanguageToggle = ({ language, toggleLanguage }) => {
	return (
		<motion.button
			onClick={toggleLanguage}
			whileHover={{ scale: 1.1 }}
			whileTap={{ scale: 0.9 }}
			className="relative px-3 py-1 rounded-full bg-blue-500 hover:bg-blue-600 text-white transition-colors flex items-center justify-center overflow-hidden"
			aria-label={
				language === "en" ? "Passer au français" : "Switch to English"
			}>
			<div className="flex items-center space-x-1">
				<span
					className={`font-medium text-sm transition-all duration-300 ${
						language === "en" ? "opacity-100" : "opacity-40"
					}`}>
					EN
				</span>
				<span className="mx-0.5">/</span>
				<span
					className={`font-medium text-sm transition-all duration-300 ${
						language === "fr" ? "opacity-100" : "opacity-40"
					}`}>
					FR
				</span>
				
			</div>
		</motion.button>
	);
};

// NavLink component with animation for links
const NavLink = ({ href, active, children, mobile = false, onClick }) => {
	return (
		<motion.a
			href={href}
			onClick={onClick}
			whileHover={{ scale: 1.1 }}
			whileTap={{ scale: 0.95 }}
			className={`relative transition-colors ${
				mobile ? "block py-3 px-6" : ""
			} ${
				active
					? "text-blue-400"
					: mobile
					? "text-gray-200 hover:text-blue-400"
					: "hover:text-blue-400"
			}`}>
			{children}
			{active && (
				<motion.span
					layoutId={mobile ? "activeSectionMobile" : "activeSection"}
					className={`absolute ${
						mobile
							? "left-0 w-1 h-full"
							: "bottom-[-3px] left-0 w-full h-[3px]"
					} bg-blue-400 rounded-full`}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 0.3 }}
				/>
			)}
		</motion.a>
	);
};

export default Navbar;
